// extracted by mini-css-extract-plugin
module.exports = {"sideDrawer":"SideDrawer_sideDrawer__U3LB_","open":"SideDrawer_open__2aNql","closed":"SideDrawer_closed__10UFC","logo":"SideDrawer_logo__3vGDH"};